import React from "react";
import SupportHero from "../components/support/SupportHero";
import SupportOptions from "../components/support/SupportOptions";
import SupportReady from "../components/support/SupportReady";
import SupportCTA from "../components/support/SupportCTA";

export default function SupportPage() {
  return (
    <>
      <SupportHero />
      <SupportOptions />
      <SupportReady />
      <SupportCTA />
    </>
  );
}
